import React from 'react';
import { useOutletContext } from 'react-router-dom';
import { useEntityList } from '../../data/entities';
import OrgAgents from '../../components/OrgAgents';
import AgentWeave from '../../components/AgentWeave';
import SwarmBoard from '../../components/SwarmBoard';

// Agent IO: the swarm board first (live coordinator runs, or the scripted
// replay when idle), the backbone map folded below it, then the org's
// agents: voice, access, look, install (the install is nventr Agent).
export default function AgentIOModule() {
  const { org, myRole } = useOutletContext();
  const { docs: agents } = useEntityList('agent', { org: org.id });
  return (
    <div data-nova-note="Agent IO (preview): specialists from the agent library coordinated on one objective; none can commit — the gate and the write stay in the nQube pipeline. NoVA: create_agent, update_agent, build_pipeline with an agentio block.">
      <h1 style={{ margin: 0 }}>Agent IO <span className="pf-preview-tag">preview</span></h1>
      <p className="cs-help" style={{ marginTop: 4, marginBottom: 12 }}>
        Specialists from your library, coordinated on one objective: the coordinator names roles,
        they share notes and ask for each other, a judge closes each round. None of them can commit —
        the gate and the write stay in the nQube pipeline.
      </p>
      <SwarmBoard org={org} />
      <details style={{ margin: '12px 0' }}>
        <summary className="cs-help">How agents ride the backbone (map)</summary>
        <AgentWeave agents={agents} />
      </details>
      <OrgAgents org={org} myRole={myRole} />
    </div>
  );
}
